import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "../services/toaster.css";
import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import MainLayout from "../components/layout/MainLayout";
import ExpenseType from "../pages/settings/ExpenseType";
import GradeLimit from "../pages/settings/GradeLimit";
import NumberingSeries from "../pages/settings/NumberingSeries";
import MasterSetting from "../pages/settings/MasterSetting";
import CashLimit from "../pages/settings/CashLimit";
import PTCash from "../pages/settings/PTCash";
import MyRequest from "../pages/dashboard/MyRequest";
import MyAuthorisations from "../pages/dashboard/MyAuthorisation";
import NewExpense from "../pages/NewExpense/NewExpense";
import MyEdit from "../pages/dashboard/MyEdit";

import useAuthStore from "../services/authStore";
import { Navigate } from "react-router-dom";

function AppContent() {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const token = useAuthStore((state) => state.token);

  useEffect(() => {
    const initAuth = async () => {
      const params = new URLSearchParams(location.search);
      const urlToken = params.get("token");

      if (urlToken) {
        try {
          const decodedUser = jwtDecode(urlToken);

          const store = useAuthStore.getState();

          store.setToken(urlToken);
          store.setUserData(decodedUser);

          await store.getCompanyDetails(); // company API
          await store.generateIntegrationToken(); // ✅ THIS WAS MISSING

          navigate("/", { replace: true });
        } catch (error) {
          console.error("Invalid token");
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [location.search, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!token) {
    return <div>Unauthorized</div>;
  }

  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Navigate to="/requests/all" replace />} />
        <Route path="expensetype" element={<ExpenseType />} />
        <Route path="grade-limit" element={<GradeLimit />} />
        <Route path="numbering-series" element={<NumberingSeries />} />
        <Route path="master-setting" element={<MasterSetting />} />
        <Route path="cash-limited" element={<CashLimit />} />
        <Route path="pt-cash" element={<PTCash />} />

        <Route path="/requests/:status" element={<MyRequest />} />
        <Route path="/authorisations/:status" element={<MyAuthorisations />} />
        <Route path="/new-expense" element={<NewExpense />} />
        <Route path="/edit-expense/:id" element={<MyEdit />} />
      </Route>
    </Routes>
  );
}
export default function AppRoutes() {
  return (
    <BrowserRouter>
      <AppContent />{" "}
    </BrowserRouter>
  );
}
